/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiCustomListRecordStatus } from './InternalApiCustomListRecordStatus';
import {
    InternalApiCustomListRecordStatusFromJSON,
    InternalApiCustomListRecordStatusFromJSONTyped,
    InternalApiCustomListRecordStatusToJSON,
    InternalApiCustomListRecordStatusToJSONTyped,
} from './InternalApiCustomListRecordStatus';
import type { InternalApiUserBasicDetails } from './InternalApiUserBasicDetails';
import {
    InternalApiUserBasicDetailsFromJSON,
    InternalApiUserBasicDetailsFromJSONTyped,
    InternalApiUserBasicDetailsToJSON,
    InternalApiUserBasicDetailsToJSONTyped,
} from './InternalApiUserBasicDetails';

/**
 * a custom list record
 * @export
 * @interface InternalApiCustomListRecord
 */
export interface InternalApiCustomListRecord {
    /**
     * External unique record ID
     * @type {string}
     * @memberof InternalApiCustomListRecord
     */
    id: string;
    /**
     * 
     * @type {InternalApiUserBasicDetails}
     * @memberof InternalApiCustomListRecord
     */
    recordCreatedBy?: InternalApiUserBasicDetails;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiCustomListRecord
     */
    recordCreatedTime?: Date;
    /**
     * 
     * @type {InternalApiUserBasicDetails}
     * @memberof InternalApiCustomListRecord
     */
    lastUpdatedBy?: InternalApiUserBasicDetails;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiCustomListRecord
     */
    lastUpdatedTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiCustomListRecord
     */
    endTime?: Date;
    /**
     * Key value pair where key is `string` and value one of following: `array`, `object`, `string`. Keys can be in snake case (e.g. `first_name`) or camel case (e.g. `firstName`)
     * 
     * @type {{ [key: string]: object; }}
     * @memberof InternalApiCustomListRecord
     */
    attributes: { [key: string]: object; };
    /**
     * 
     * @type {number}
     * @memberof InternalApiCustomListRecord
     */
    historicSchemaId?: number;
    /**
     * 
     * @type {InternalApiCustomListRecordStatus}
     * @memberof InternalApiCustomListRecord
     */
    status?: InternalApiCustomListRecordStatus;
}



/**
 * Check if a given object implements the InternalApiCustomListRecord interface.
 */
export function instanceOfInternalApiCustomListRecord(value: object): value is InternalApiCustomListRecord {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('attributes' in value) || value['attributes'] === undefined) return false;
    return true;
}

export function InternalApiCustomListRecordFromJSON(json: any): InternalApiCustomListRecord {
    return InternalApiCustomListRecordFromJSONTyped(json, false);
}

export function InternalApiCustomListRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCustomListRecord {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'recordCreatedBy': json['recordCreatedBy'] == null ? undefined : InternalApiUserBasicDetailsFromJSON(json['recordCreatedBy']),
        'recordCreatedTime': json['recordCreatedTime'] == null ? undefined : (new Date(json['recordCreatedTime'])),
        'lastUpdatedBy': json['lastUpdatedBy'] == null ? undefined : InternalApiUserBasicDetailsFromJSON(json['lastUpdatedBy']),
        'lastUpdatedTime': json['lastUpdatedTime'] == null ? undefined : (new Date(json['lastUpdatedTime'])),
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
        'attributes': json['attributes'],
        'historicSchemaId': json['historicSchemaId'] == null ? undefined : json['historicSchemaId'],
        'status': json['status'] == null ? undefined : InternalApiCustomListRecordStatusFromJSON(json['status']),
    };
}

export function InternalApiCustomListRecordToJSON(json: any): InternalApiCustomListRecord {
    return InternalApiCustomListRecordToJSONTyped(json, false);
}

export function InternalApiCustomListRecordToJSONTyped(value?: InternalApiCustomListRecord | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'recordCreatedBy': InternalApiUserBasicDetailsToJSON(value['recordCreatedBy']),
        'recordCreatedTime': value['recordCreatedTime'] == null ? value['recordCreatedTime'] : value['recordCreatedTime'].toISOString(),
        'lastUpdatedBy': InternalApiUserBasicDetailsToJSON(value['lastUpdatedBy']),
        'lastUpdatedTime': value['lastUpdatedTime'] == null ? value['lastUpdatedTime'] : value['lastUpdatedTime'].toISOString(),
        'endTime': value['endTime'] == null ? value['endTime'] : value['endTime'].toISOString(),
        'attributes': value['attributes'],
        'historicSchemaId': value['historicSchemaId'],
        'status': InternalApiCustomListRecordStatusToJSON(value['status']),
    };
}

